import * as React from 'react';
import { IProductOrderTab } from '@applications/order-tracker/config/order-tracker-new-common/types';
import { progressTrackerBusinessRules } from '@applications/order-tracker/config/order-tracker-new-common/order-products-utils'
import ProgressTracker from 'ted-ui/build/ProgressTracker';
import { updatedActivityList } from '../../updated-activity-list';
const iconDevelopmentURL = require('../../../../../../../../images/able-sprites.svg');

const ProgressDetails = ({ product }: IProductOrderTab) => {
  const { showProgressTrackerStages } = progressTrackerBusinessRules(product)
  return (
    <React.Fragment>
      {showProgressTrackerStages() && (
        <ProgressTracker
          developmentUrl={iconDevelopmentURL}
          titleOrder={4}
          trackerValues={updatedActivityList(product)}
        />
      )}
    </React.Fragment>
  );
}

export default ProgressDetails;
